import CustomButton from '../../../../Button/CustomButton.tsx';

import { StyledModalcomponentMuestras } from '../../../Styled';

const NotiOrdenesDeTrabajo = (props) => {

  const propsNoti = (datos) => {
    console.log(datos);
    const titulo = datos?.titulo;
    return { titulo }
  }

  const { titulo } = propsNoti(props.datos);


  let estado = props.datos.datos.estadoCompleto

  const renderLabel = () => {
    let tituloLabel = null;
    let descripcionLabel = null;

    // Get the first word of accion_ef_ot in lowercase
    const primeraPalabra = estado.accion_ef_ot ? estado.accion_ef_ot.split(' ')[0].toLowerCase() : '';
    
    // tituloLabel = `${estado.accion_ef_ot} OT`;
    tituloLabel = `${primeraPalabra.toUpperCase()} OT`;
    
    // Only set descripcionLabel if codigo_template_email_ef_ot is not empty
    if (estado.codigo_template_email_ef_ot !== "") {
      if (estado.accion_ef_ot === "Notificar OT") {
        descripcionLabel = `Al ${primeraPalabra} la OT, se enviará un mail al cliente, indicando que se recibieron las muestras y se inició el proceso de análisis de las mismas.`
      }

      if (estado.accion_ef_ot === "Finalizar OT") {
        descripcionLabel = `Al ${primeraPalabra} la OT, se enviará un mail al cliente, indicando que se realizaron todos los análisis correspondientes a todas las muestras de la OT.`
      }
    }

    return { tituloLabel, descripcionLabel };
  }

  const renderButtons = () => {
    return (
      <>
        <CustomButton
          label={"Si"}
          variant="contained"
          className={`buttonColorDefault btn`}
          type="submit"
          onClick={props.onClick2}
        // disabled={!editar ? !formCompleto : false}
        />
        <CustomButton
          onClick={props.onClick}
          label={"No"}
          variant="contained"
          className={`buttonColorDisabled btn`}
        />
      </>
    );
  };

  return (
    <StyledModalcomponentMuestras sx={{
      maxWidth: {
        xs: '100%', 
        sm: '100%',   
        md: '38%'     
      }
    }}>
      <div className="notiOrdenesDeTrabajo">
        <div className="divLabel">
          <p className="titulo">{renderLabel().tituloLabel}</p>
        </div>
        <div className="divBody">
          {renderLabel().descripcionLabel && <div className="divDescripcion">
            <p className="descripcion">{renderLabel().descripcionLabel}</p>
          </div>}
          <p className="confirmacion">Confirma el cambio de estado?</p>
          <div className="divButtonsItem">
            {renderButtons()}
          </div>
        </div>
      </div>
    </StyledModalcomponentMuestras>
  )
}

export default NotiOrdenesDeTrabajo